import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface DeleteAccountCardProps {
  onDeleteRequested: () => void;
}

export function DeleteAccountCard({ onDeleteRequested }: DeleteAccountCardProps) {
  const { t } = useTranslation();
  const [deleteAccountChecked, setDeleteAccountChecked] = useState(false);

  return (
    <div className="card bg-base-100 max-md:rounded-none">
      <div className="bg-secondary text-secondary-content px-4 py-3 rounded-t-[var(--radius-box)] max-md:rounded-none">
        <h2 className="text-xl font-bold">{t("settings.delete_account")}</h2>
      </div>
      <div className="card-body">
        <div className="flex flex-col gap-2">
          <p className="font-bold">{t("settings.delete_account_confirmation_prompt")}</p>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={deleteAccountChecked}
              onChange={() => setDeleteAccountChecked(!deleteAccountChecked)}
              className="checkbox checkbox-primary"
            />
            <span>{t("settings.delete_account_confirmation")}</span>
          </label>
          <button
            className="btn btn-primary w-fit"
            type="button"
            disabled={!deleteAccountChecked}
            onClick={onDeleteRequested}
          >
            {t("settings.delete_button_label")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccountCard;
